import React, { useState, useEffect } from 'react';
import './Portfolio.css';
import { ReactComponent as AlifLogo } from './assets/alif-logo.svg';
import { ReactComponent as AkeanaLogo } from './assets/akeana-logo.svg';
import { ReactComponent as RetymLogo } from './assets/retym-logo.svg';
import { ReactComponent as LumilensLogo } from './assets/lumilens-logo.svg';

const COMPANIES = [
  {
    name: 'Alif Semiconductor',
    href: 'https://alifsemi.com/',
    Logo: AlifLogo,
    logoClassName: 'portfolio__logo portfolio__logo--alif',
    description: 'Next generation microcontrollers, powering AI at the edge'
  },
  {
    name: 'Akeana',
    href: 'https://www.akeana.com/',
    Logo: AkeanaLogo,
    logoClassName: 'portfolio__logo',
    description: 'RISC-V technology, elevated to world-class performance levels'
  },
  {
    name: 'Retym',
    href: 'https://www.retym.com/',
    Logo: RetymLogo,
    logoClassName: 'portfolio__logo',
    description: 'Leading-edge optical infrastructure for the datacenter, delivered at the speed of light'
  },
  {
    name: 'Lumilens',
    href: 'https://www.lumilens.com/',
    Logo: LumilensLogo,
    logoClassName: 'portfolio__logo portfolio__logo--lumilens',
    description: 'Photonic interconnects for massively scaling out – and scaling up – AI compute infrastructure'
  }
];

const Portfolio = ({ areCardsAlwaysActive = false }) => {
  const [isVisible, setIsVisible] = useState(false); 

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, 2500);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className={`portfolio ${areCardsAlwaysActive ? 'portfolio--cards-active' : ''}`}>
      <div className='portfolio__grid-wrap'>
        <ul className={`portfolio__grid ${isVisible ? 'portfolio__grid--visible' : ''}`}>
          {COMPANIES.map(({ name, href, Logo, logoClassName, description }) => (
            <li className='portfolio__card' key={name}>
              <a className='portfolio__card-link' href={href} aria-label={name}>
                <div className={logoClassName}>
                  <Logo />
                </div>
                <p className='portfolio__description'>
                  {description}
                </p>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Portfolio;
